

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import ITheme from '../themes/ITheme';
import { IAppState } from '../store/app-store';
import Themes from '../themes';

@Component
  export default class LocaleDropdown extends Vue {
    locales: string[] = ['en', 'fi', 'sv'];

    changeLocale(locale: string) {
      this.$store.commit('app/changeLocale', locale);
      // Due to a11y requirements, we unfortunately need to reload the page
      // if we don't want to manually reset all state to "initial"
      window.setTimeout(() => {window.location.reload()}, 200);
    }

    get currentLocale() {
      return this.appState.locale;
    }

    get appState(): IAppState {
      return this.$store.state.app;
    }

    get themes(): ITheme[] {
      return this.appState.themes;
    }

    get theme(): ITheme {
      const theme = this.themes.find(t => t.id === this.themeId);
      return theme ? theme : Themes.themeDefault;
    }

    get themeId() {
        return this.appState.themeId;
    }

    showLanguageSelector(): boolean {
      let host = document.location.host.replace(/:\d+$/, ''); // Strip port number if present
      let isInUkOrUs = host.endsWith('.uk') || host.endsWith('.us');
      
      return isInUkOrUs ? this.currentLocale !== 'en' : true;
    }

  }
